module.exports = __webpack_public_path__ + "static/img/9bg_9.320c698.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/9bg_9.png
// module id = 781
// module chunks = 1